var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1197_34100)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.23366 8.23317C7.98804 8.46204 7.79103 8.73805 7.65439 9.04471C7.51775 9.35137 7.44428 9.68242 7.43835 10.0181C7.43243 10.3538 7.49418 10.6872 7.61992 10.9985C7.74565 11.3098 7.9328 11.5926 8.1702 11.83C8.40759 12.0674 8.69037 12.2545 9.00167 12.3802C9.31296 12.506 9.64639 12.5677 9.98207 12.5618C10.3177 12.5559 10.6488 12.4824 10.9555 12.3458C11.2621 12.2091 11.5381 12.0121 11.767 11.7665M8.94199 4.23317C9.29308 4.18943 9.64652 4.16716 10.0003 4.1665C15.8337 4.1665 18.3337 9.99984 18.3337 9.99984C17.9611 10.7974 17.4938 11.5473 16.942 12.2332M5.50866 5.50817C3.85137 6.63702 2.52522 8.18755 1.66699 9.99984C1.66699 9.99984 4.16699 15.8332 10.0003 15.8332C11.5969 15.8375 13.1593 15.3708 14.492 14.4915M1.66699 1.6665L18.3337 18.3332",
    stroke: "#C5D1D8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1197_34100"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.d3f1019b89b35c2e7c64ec85d687a7a0.svg";
export { ForwardRef as ReactComponent };